// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-content {
  overflow-x: auto;
}

.table-container {
  width: 100%; /* Adjust the width as needed */
  height: 100%; /* Adjust the width as needed */
  overflow: auto; /* Enable horizontal scrollbar */
}

table {
  width: 100%; /* Adjust the width as needed */
  border-collapse: collapse;
}

/* Optional: Add styling for table cells, borders, etc. */
table td, table th {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center; /* Align text in the center */
}`, "",{"version":3,"sources":["webpack://./src/framework/components/list/api-table/api-table.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,YAAY,EAAE,+BAA+B;EAC7C,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB,EAAE,6BAA6B;AACnD","sourcesContent":[".scroll-content {\n  overflow-x: auto;\n}\n\n.table-container {\n  width: 100%; /* Adjust the width as needed */\n  height: 100%; /* Adjust the width as needed */\n  overflow: auto; /* Enable horizontal scrollbar */\n}\n\ntable {\n  width: 100%; /* Adjust the width as needed */\n  border-collapse: collapse;\n}\n\n/* Optional: Add styling for table cells, borders, etc. */\ntable td, table th {\n  border: 1px solid #ccc;\n  padding: 8px;\n  text-align: center; /* Align text in the center */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
